<template>
  <div>
    <config-main-title v-if="!id_operadora">
      Restrições Gerais
    </config-main-title>
    
    <az-break-title title="Restrições" v-else/>

    <div>
      <div class="row mb-3">
        <div class="col col-12 col-md-6">
          <az-input icon="fas fa-search" v-model="search" />
        </div>
        <div class="col col-12 col-md-3 d-flex flex-column">
            <div class="btn-group mb-1" role="group" aria-label="Basic example">
                <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                @click="viewMode = 'A'">
                    Ativos
                </button>
                <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                @click="viewMode = 'T'">
                    Todos
                </button>
            </div>
        </div>
        <div class="col col-12 col-md-3 d-flex flex-column">
          <button
            type="button"
            class="btn btn-outline-success"
            @click="incluir ()"
          >Incluir Restrição</button>
        </div>
      </div>
    </div>

    <div v-if="!lista || !lista.length">
      <div class="text-right">
        <button type="button" class="btn btn-outline-primary btn-sm mb-3 mr-2" v-if="!search && id_operadora" @click="copiar_de()">
          <i class="fa-solid fa-copy mr-2"></i>
          Copiar de...
        </button>
      </div>

      <az-empty-state
        icon="fas fa-search"
        msg="Nenhuma restrição identificada."
        :action="!search ? 'Incluir Restrição' : ''"
        :method="incluir"
      />
    </div>

    <div v-if="lista && lista.length">

      <ordenacao-dragn-drop v-model="pode_ordenar" :search="search">
        <template v-slot:opcoes>
          <button type="button" class="btn btn-outline-primary btn-sm mb-3 mr-2" @click="copiar_de()" v-if="id_operadora">
            <i class="fa-solid fa-copy mr-2"></i>
            Copiar de...
          </button>
        </template>
      </ordenacao-dragn-drop>
 
      <div class="list-group mb-3 az-anime-surgir mb-3">
        <draggable v-model="lista" @start="drag=true" @end="drag=false; atualizarOrdem();" ghost-class="primary"
          :draggable="search || !pode_ordenar ? '.none' : '.list-group-item'">
          <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id">
            <span>
              <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">{{ dado.search }}</a>
              <small class="ml-3 badge badge-secondary">#{{ dado.id_restricao_operadora }}</small>
            </span>
            <span class="d-flex">
              <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="'ativo-' + id"
                  v-model="dado.fl_ativo"
                  @change="toggle(dado)"
                />
                <label class="custom-control-label" :for="'ativo-' + id"></label>
              </div>
            </span>
          </li>
        </draggable>
      </div>

      <br><br><br>
    </div>

    <!-- Modal Copiar De... -->
    <div class="modal fade" id="copiarDeRestricoesModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Copiar de...</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <az-input
              type="autocomplete"
              optionsMode="aql"
              optionsSync2="false"
              service="operadoras.index"
              optionsData="id_operadora"
              :optionsReload="true"
              label="Copiar de..."
              v-model="copia_origem"
              @input="buscar_restricoes_de()" />

            <div class="mt-3" v-if="restricoes_origem && restricoes_origem.length">
              <div class="mb-3">
                <button type="button" class="btn btn-outline-primary btn-sm" @click="marcar_copia_todas()">
                  Todas
                </button>

                <span class="badge badge-secondary ml-2">{{ restricoes_origem_selecionadas.length }}</span>
              </div>

              <div class="input-group mb-1" v-for="(rest, irx) in restricoes_origem" :key="irx">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <input type="checkbox" aria-label="Checkbox for following text input" v-model="rest.fl_ativo">
                  </div>
                </div>
                <label class="form-control" aria-label="Text input with checkbox">
                  {{ rest.search }}
                </label>
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon2">#{{ rest.id_restricao_operadora }}</span>
                </div>
              </div>

            </div>

            <br><br><br><br><br><br><br><br><br><br>

            <pre class="alert alert-info mt-3" v-if="false">{{ restricoes_origem }}</pre>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <az-submit @click="salvar_copiar_de()" v-if="restricoes_origem_selecionadas.length">Copiar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="restricaoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header" v-if="item">
            <h5 class="modal-title" id="exampleModalLabel">
              Restrição 
              <span class="badge badge-secondary ml-3">
                {{ item && item.id_restricao_operadora ? '#' + item.id_restricao_operadora : 'Nova' }}
              </span>
              <span class="badge badge-danger ml-3" v-if="!item.fl_ativo">Inativo</span>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="item">
            <div class="row">
              <div class="col col-12">
                <az-input
                  sizing="sm"
                  label="Título"
                  v-model="item.st_titulo" />
              </div>
            </div>
            <div class="form-row">
              <div class="col col-12 col-md-3">
                <az-input
                  sizing="sm"
                  label="Tipo do Item"
                  type="select"
                  optionsMode="json"
                  optionsData="id"
                  optionsDisplay="search"
                  :optionsList="[{ id: 'PRO', search: 'Procedimento' }, { id: 'MAT', search: 'Material' }, { id: 'MED', search: 'Medicamento' }]"
                  required
                  :validate="validate"
                  v-model="item.st_tipo_restricao"
                />
              </div>
              <div class="col col-12 col-md-3" v-if="item.id_plano">
                <az-input
                  label="Plano"
                  type="select"
                  optionsMode="aql"
                  :optionsSync="false"
                  service="planos.index"
                  optionsData="id_plano"
                  optionsDisplay="search"
                  optionsName="planos-regra"
                  :optionsReload="true"
                  :optionsParm="{ where: { id_operadora: this.id_operadora } }"
                  :validate="validate"
                  v-model="item.id_plano"
                />
              </div>
              <div class="col col-12 col-md-3" v-if="item.st_tipo_restricao == 'PRO' && item.id_classe_procedimento">
                <az-input
                  label="Classificação"
                  service="classe_procedimentos.index"
                  type="select"
                  optionsMode="aql"
                  :optionsSync="false"
                  optionsData="id_classe_procedimento"
                  optionsDisplay="search"
                  :validate="validate"
                  :edicao="!item.id_procedimento"
                  v-model="item.id_classe_procedimento"
                />
              </div>
              <div class="col col-12 col-md-3" v-if="item.st_tipo_restricao == 'PRO' && item.id_procedimento">
                <!-- procedimentos.index -->
                <az-input
                  label="Procedimento"
                  :validate="validate"
                  type="autocomplete"
                  optionsName="procedimentos.agenda" 
                  optionsMode="aql"
                  optionsData="id_procedimento"
                  optionsDisplay="search"
                  :optionsSync="false"
                  :optionsInitial="item.procedimento ? item.procedimento.search : ''"
                  :edicao="!item.id_classe_procedimento"
                  v-model="item.id_procedimento"
                />
              </div>
              <div class="col col-12 col-md-6" v-if="item.st_tipo_restricao == 'MAT' && item.id_material">
                <az-input
                  label="Material"
                  :validate="validate"
                  type="autocomplete"
                  service="materiais.index"
                  optionsData="id_material"
                  optionsDisplay="search"
                  :optionsInitial="item.material ? item.material.search : ''"
                  v-model="item.id_material"
                />
              </div>
              <div class="col col-12 col-md-6" v-if="item.st_tipo_restricao == 'MED' && item.id_medicamento">
                <az-input
                  sizing="sm" 
                  label="Medicamentos"
                  :validate="validate"
                  type="autocomplete"
                  service="medicamentos.index"
                  optionsData="id_medicamento"
                  optionsDisplay="search"
                  :optionsInitial="item.medicamento ? item.medicamento.search : ''"
                />
              </div>
              <div class="col col-12 col-md-9">
                <az-input sizing="sm" label="Observação" v-model="item.st_observacao" />
              </div>
            </div>

            <!-- Filtros -->
            <filtro-model v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />

            <!-- OpçÕes -->

            <az-sub-title title="Opções" />

            <div class="form-row">
              <div class="col col-12 col-md-3">
                <az-input
                  sizing="sm"
                  label="Não Possui Cobertura"
                  type="checkbox-group"
                  v-model="item.fl_nao_possui_cobertura"
                />
              </div>
              <div class="col col-12 col-md-3" v-if="item.fl_nao_possui_cobertura">
                <az-input
                  sizing="sm"
                  label="Bloquer Lançamento"
                  type="checkbox-group"
                  v-model="item.fl_bloqueia_lancamento"
                />
              </div>
              <div class="col col-12 col-md-3" v-if="!item.fl_nao_possui_cobertura">
                <az-input
                  sizing="sm"
                  label="Autorização Prévia"
                  type="checkbox-group"
                  v-model="item.fl_autorizacao_previa"
                />
              </div>
              <div
                class="col col-12 col-md-3"
                v-if="!item.fl_nao_possui_cobertura && item.fl_autorizacao_previa"
              >
                <az-input
                  sizing="sm"
                  label="Senha para Autorização"
                  type="checkbox-group"
                  v-model="item.fl_senha_autorizacao"
                />
              </div>
              <div class="col col-12 col-md-3" v-if="!item.fl_nao_possui_cobertura">
                <az-input
                  sizing="sm"
                  label="CID para Atendimento"
                  type="checkbox-group"
                  v-model="item.fl_cid_atendimento"
                />
              </div>
            </div>

            <!-- Tipos de Restrição -->

            <az-sub-title title="Tipos de Restrição" />

            <!-- Por Prestador -->

            <az-input
              sizing="sm"
              label="Por Prestador"
              type="checkbox-group"
              v-model="item.fl_restricao_medico"
              v-if="item.fl_restricao_medico"
            />

            <div class="row mb-2" v-if="item.fl_restricao_medico">
              <div class="col col-12 col-md-3">
                <az-input
                  icon="fas fa-plus"
                  type="select"
                  optionsMode="aql"
                  service="medico_operadoras.index"
                  :optionsSync="false"
                  :optionsParm="{ where: { id_operadora: this.id_operadora, fl_ativo: true } }"
                  v-model="novoMedico"
                  @input="adicionarMedico()"
                />
              </div>
              <div
                class="col col-12 col-md-3"
                v-for="(rom, im) in item.restricao_operadora_medicos"
                :key="im"
              >
                <az-input type="checkbox-group" :label="rom.medico.search" v-model="rom.fl_ativo" />
              </div>
            </div>

            <!-- Intervalo -->

            <div v-if="!item.fl_nao_possui_cobertura">
              <az-input
                sizing="sm"
                label="Intervalo de realização de procedimentos"
                type="checkbox-group"
                v-model="item.fl_intervalo_realizacao"
              />

              <div class="row mb-2" v-if="item.fl_intervalo_realizacao">
                <div class="col col-12 col-md-4">
                  <az-input
                    sizing="sm"
                    label="Intervalo (em dias)"
                    type="number"
                    required
                    :validate="validate"
                    v-model="item.in_intervalo_realizacao_dias"
                  />
                </div>
              </div>
            </div>

            <!-- Intervalo -->

            <div v-if="!item.fl_nao_possui_cobertura">
              <az-input
                sizing="sm"
                label="Limite de quantidade por dia"
                type="checkbox-group"
                v-model="item.fl_limite_quantidade"
              />

              <div class="row mb-2" v-if="item.fl_limite_quantidade">
                <div class="col col-12 col-md-4">
                  <az-input
                    sizing="sm"
                    label="Quantidade por Dia"
                    type="number"
                    required
                    :validate="validate"
                    v-model="item.in_quantidade_limite_dia"
                  />
                </div>
              </div>
            </div>

            <!-- Por Idade -->

            <az-input sizing="sm" label="Por Idade" type="checkbox-group" v-model="item.fl_idade" />

            <div class="row mb-2" v-if="item.fl_idade">
              <div class="col col-12 col-md-3">
                <az-input
                  sizing="sm"
                  label="Idade Mínima"
                  type="number"
                  :validate="validate"
                  v-model="item.in_idade_minima"
                />
              </div>
              <div class="col col-12 col-md-3">
                <az-input
                  sizing="sm"
                  label="Idade Mínima em..."
                  type="button-group"
                  :optionsList="[{ id: 'A', search: 'Anos' }, { id: 'D', search: 'Dias' }]"
                  required
                  :validate="validate"
                  v-model="item.ch_tipo_idade_minima"
                />
              </div>
              <div class="col col-12 col-md-3">
                <az-input
                  sizing="sm"
                  label="Idade Máxima"
                  type="number"
                  required
                  :validate="validate"
                  v-model="item.in_idade_maxima"
                />
              </div>
              <div class="col col-12 col-md-3">
                <az-input
                  sizing="sm"
                  label="Idade Máxima em..."
                  type="button-group"
                  :optionsList="[{ id: 'A', search: 'Anos' }, { id: 'D', search: 'Dias' }]"
                  required
                  :validate="validate"
                  v-model="item.ch_tipo_idade_maxima"
                />
              </div>
            </div>

            <!-- Valor Mínimo -->

            <az-input sizing="sm" label="Valor Mínimo" type="checkbox-group" v-model="item.fl_valor_minimo" />

            <div class="row mb-2" v-if="item.fl_valor_minimo">
              <div class="col col-12 col-md-4">
                <az-input
                  sizing="sm"
                  label="Valor Mínimo"
                  type="money"
                  required
                  :validate="validate"
                  v-model="item.dc_valor_minimo"
                />
              </div>
            </div>

            <!-- Item Alternativo -->
            <div v-if="item.fl_nao_possui_cobertura">
              <az-input
                sizing="sm"
                label="Item Alternativo"
                type="checkbox-group"
                v-if="!item.fl_em_conjunto"
                v-model="item.fl_item_alternativo"
              />

              <az-input
                sizing="sm"
                label="Não pode em conjunto com outro procedimento"
                type="checkbox-group"
                v-if="!item.fl_item_alternativo"
                v-model="item.fl_em_conjunto"
              />

              <div class="row mb-2" v-if="item.fl_item_alternativo || item.fl_em_conjunto">
                <div class="col col-12">
                  <az-input
                    sizing="sm"
                    label="Procedimento"
                    :validate="validate"
                    required
                    type="autocomplete"
                    service="procedimentos.index"
                    optionsDisplay="search"
                    v-model="item.alternativo"
                  />
                </div>
              </div>
            </div>

            <!-- Tempo de Autorização -->
            <div v-if="!item.fl_nao_possui_cobertura && item.fl_autorizacao_previa">
              <az-input
                sizing="sm"
                label="Tempo para autorização"
                type="checkbox-group"
                v-model="item.fl_tempo_autorizacao_cirurgia"
              />

              <div class="row mb-2" v-if="item.fl_tempo_autorizacao_cirurgia">
                <div class="col col-12">
                  <az-input
                    sizing="sm"
                    label="Tempo necessário para autorização para marcação (em dias)"
                    :validate="validate"
                    required
                    type="number"
                    v-model="item.in_tempo_autorizacao_cirurgia_dias"
                  />
                </div>
              </div>
            </div>

            <!-- Obter Autorização ao Agendar -->
            <az-input sizing="sm" label="Obter Autorização Após Agendamento (com solicitação do pedido médico)" type="checkbox-group" 
                v-model="item.fl_obter_autoriz_ao_agendar" v-if="!item.fl_nao_possui_cobertura && item.fl_autorizacao_previa" />

            <!-- Obter Autorização ao Atender -->
            <az-input sizing="sm" label="Obter Autorização Após Atendimento (não on-line)" type="checkbox-group" 
                v-model="item.fl_obter_autoriz_ao_atender" v-if="!item.fl_nao_possui_cobertura && item.fl_autorizacao_previa" />

            <template v-if="item.st_tipo_restricao == 'PRO'">

                <!-- Obter Autorização ao Requisitar -->
                <az-input sizing="sm" label="Obter Autorização a partir da requisição médica (feita no consultório)" type="checkbox-group" 
                    v-model="item.fl_obter_autoriz_ao_requisitar" v-if="!item.fl_nao_possui_cobertura && item.fl_autorizacao_previa" />

                <!-- Obter Autorização ao Requisitar -->
                <az-input sizing="sm" label="Agendar somente com solicitação de autorização realizada" type="checkbox-group" 
                    v-model="item.fl_agenda_com_solic_aut" v-if="!item.fl_nao_possui_cobertura && item.fl_autorizacao_previa" />

                <!-- Obter Autorização ao Requisitar -->
                <az-input sizing="sm" label="Exige Pacote de Sessão para o Lançamento" type="checkbox-group" 
                    v-model="item.fl_exige_pacote_sessao" v-if="!item.fl_nao_possui_cobertura" />

                <!-- Exige Relatório Médico -->
                <az-input sizing="sm" label="Necessita de Relatório Médico" type="checkbox-group" 
                    v-model="item.fl_exige_relatorio_medico" v-if="!item.fl_nao_possui_cobertura && item.fl_autorizacao_previa" />

                <!-- Quantidade Padrão para o Pedido -->
                <az-input sizing="sm" label="Definir quantidade padrão para a requisição médica" type="checkbox-group" 
                    v-model="item.fl_pedido_qt_padrao" v-if="!item.fl_nao_possui_cobertura" />

                <div class="row mb-2" v-if="item.fl_pedido_qt_padrao">
                <div class="col col-12">
                    <az-input
                    sizing="sm"
                    label="Quantidade Padrão"
                    :validate="validate"
                    required
                    type="number"
                    v-model="item.in_pedido_qt_padrao"
                    />
                </div>
                </div>

                <!-- Quebrar Requisição -->
                <az-input sizing="sm" label="Quebrar a requisição médica por classificação" type="checkbox-group" 
                v-model="item.fl_pedido_quebra_classificacao" v-if="!item.fl_nao_possui_cobertura" />

                <!-- Bloquear Lançamento pelo Consultório/Assistência -->
                <az-input sizing="sm" label="Bloquear Lançamento pelo Consultório/Assistência" type="checkbox-group" 
                    v-model="item.fl_block_add_cons" v-if="!item.fl_nao_possui_cobertura" />

            </template>

            <template v-if="item.st_tipo_restricao == 'MED'">
                <!-- Cobrança de Material Agregado -->
                <az-input 
                    sizing="sm" 
                    label="Não cobrar materiais agregados dispensados a partir do consumo no estoque"
                    type="checkbox-group" 
                    v-model="item.fl_block_cobra_mat_agregado" 
                    v-if="!item.fl_nao_possui_cobertura" />
            </template>
            
            <!-- Escopo de Autorização -->
            <az-input 
              class="mt-3"
              sizing="sm" 
              label="Autorização de Sessões" 
              type="select" 
              :optionsList="[
                { id: 'P', search: 'Quando atendimento em sessões, autorizar as sessões em conjunto' },
                { id: 'S', search: 'Quando atendimento em sessões, autorizar cada sessão individualmente' }
              ]"
              optionsData="id"
              v-model="item.st_escopo_pacote" 
              v-if="!item.fl_nao_possui_cobertura && item.fl_autorizacao_previa" />

          </div>
          <div class="modal-footer">
            <az-audit-log-button v-if="item && item.id_restricao_operadora" model="restricaoOperadora" :id="item.id_restricao_operadora" />
            <az-submit color="outline-danger" @click="remover ()" v-if="item && item.id_restricao_operadora && 1 == 0">Remover</az-submit>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="atualizar ()">Atualizar</az-submit>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import $ from "jquery";
import draggable from "vuedraggable";

import AzBreakTitle from "../../../util/AzBreakTitle.vue";
import AzEmptyState from "../../../util/AzEmptyState.vue";
import AzInput from "../../../shared/forms/AzInput.vue";
import AzSubTitle from "../../../util/AzSubTitle.vue";
import AzSubmit from "../../../util/AzSubmit.vue";
import FiltroModel from '../../shared/FiltroModel.vue';
import ConfigMainTitle from '../../shared/ConfigMainTitle.vue';
import OrdenacaoDragnDrop from '../../shared/OrdenacaoDragnDrop.vue';
import AzAuditLogButton from '../../../util/AzAuditLogButton.vue';

export default {
  data() {
    return {
      dados: null,
      search: "",
      validate: false,
      item: null,
      medicos: null,
      novoMedico: null,
      viewMode: 'A', 
      breadcrumb: null, 
      pode_ordenar: false, 
      copia_origem: "", 
      restricoes_origem: [], 
    };
  },

  components: {
    AzBreakTitle,
    AzEmptyState,
    AzInput,
    AzSubTitle,
    AzSubmit,
    draggable,
    FiltroModel,
    ConfigMainTitle,
    OrdenacaoDragnDrop,
    AzAuditLogButton
  },

  props: ["id_operadora"],

  computed: {
    lista: {
      get() {
        let pesquisar = this.search.trim();
        let parts = pesquisar.replace(" ", ".*");
        let match = parts;
        let reg = new RegExp(match, "i");

        return this.dados && this.dados.length
          ? this.dados.filter(item => this.viewMode == 'T' || item.fl_ativo)
            .filter(item => {
              return !this.search || reg.test(JSON.stringify(item));
            })
          : null;
      },
      set(newLista) {
        this.dados = newLista;
      }
    },

    lista_opcoes_filtro: function () { 
      let opcoes = [                                
          {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
          {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
          {id:'App\\azure\\procedimentoGrupo', search:'Grupo de Procedimento', service: 'procedimento_grupos.index'}, 
          {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
          {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
          {id:'tag-plano', search:'Classificação do Plano Particular', service: 'planos.index', tag: true},
          // {id:'tag-operadora', search:'Classificação da Operadora', service: 'operadoras.index', tag: true},
          {id:'App\\azure\\pessoa', search:'Paciente', service: 'pacientes.index', parms: { mrc: false }},
          {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index', parms: { agenda: 0 } },
          {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
          {id:'App\\azure\\recepcao', search:'Recepção', service: 'recepcaos.index', parms: { filtros: true }},
      ];
      
      switch (this.item.st_tipo_restricao) {
        case 'MAT': 
          opcoes.push({id:'App\\azure\\material', search:'Material', service: 'materiais.index'});
          break;
        case 'MED': 
          opcoes.push({id:'App\\azure\\medicamento', search:'Medicamento', service: 'medicamentos.index'});
          break;
      }
      
      if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
          opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade',service:'unidade_operacaos.index'});
          opcoes.push({id:'tag-unidade', search:'Classificação da Unidade', service: 'unidade_operacaos.index', tag: true});
      }
      
      return _.orderBy(opcoes, 'search');
    },

    restricoes_origem_selecionadas: function () { 
      if ( !this.restricoes_origem )
        return [];

      return this.restricoes_origem.filter(item => item.fl_ativo);
    }

  },

  methods: {
    marcar_copia_todas() { 
      let selecao = this.restricoes_origem.length == this.restricoes_origem_selecionadas.length ? false : true;

      this.restricoes_origem.forEach(item => { 
        item.fl_ativo = selecao;
      });
    },

    buscar_restricoes_de() { 
      if ( !this.copia_origem || this.copia_origem == this.id_operadora ) { 
        this.restricoes_origem = [];
        return;
      }

      this.$util.load(this, { 
        service: 'restricao_operadoras', 
        func: 'index', 
        parms: { 
          id_operadora: this.copia_origem,
          cadastro: true, 
        }, 
        loadTo: res => { 
          this.restricoes_origem = res.filter(item => item.fl_ativo);
        }
      });
    },

    salvar_copiar_de () { 
      this.$util.atualizar(this, { 
        service: 'operadoras', 
        func: 'copiar_restricoes', 
        dados: { 
          id_operadora: this.id_operadora, 
          lista: this.restricoes_origem_selecionadas.map(item => item.id_restricao_operadora), 
        },
        modal: 'copiarDeRestricoesModal',
        reload: true, 
      });
    },

    copiar_de () { 
      this.copia_origem = "";
      $('#copiarDeRestricoesModal').modal('show');
    },

    atualizarOrdem () { 
  
      this.$util.atualizar(this, { 
        service: 'restricao_operadoras', 
        func: 'ordem',
        dados: {
          lista: this.lista
        },
        toast: true, 
      });

    },

    adicionarMedico() {
      if (this.novoMedico) {
        if (
          !this.item.restricao_operadora_medicos.find(rom => {
            return rom.id_medico == this.novoMedico.id_medico;
          })
        ) {
          this.item.restricao_operadora_medicos.push({
            id_restricao_operadora_medico: null,
            id_medico: this.novoMedico.id_medico,
            fl_ativo: true,
            id_restricao_operadora: this.item.id_restricao_operadora,
            medico: { ...this.novoMedico.medico }
          });

          this.$nextTick(() => {
            this.novoMedico = null;
          });
        }
      }
    },

    incluir() {
      this.novoMedico = null;
      this.validate = false;
      this.item = {
        id_restricao_operadora: null,
        id_operadora: this.id_operadora,
        fl_autorizacao_previa: false,
        fl_ativo: true,
        fl_nao_possui_cobertura: false,
        fl_bloqueia_lancamento: false,
        fl_senha_autorizacao: false,
        fl_cid_atendimento: false,
        fl_item_alternativo: false,
        fl_tempo_autorizacao_cirurgia: false,
        fl_limite_quantidade: false,
        in_quantidade_limite_dia: 1,
        fl_tipo_atendimento: false,
        fl_valor_minimo: false,
        fl_idade: false,
        fl_intervalo_realizacao: false,
        fl_restricao_medico: false,
        fl_autorizacao_gih: false,
        fl_exige_auxiliar: false,
        filtros: [],
      };

      $("#restricaoModal").modal("show");
    },

    toggle(item) {
      this.$store.commit("loading", true);

      let query = {
        q: [
          {
            name: "restricao_operadoras.toggle",
            id: "toggle",
            parms: {
              ...item
            }
          }
        ]
      };

      this.axios
        .post("/aql", query)
        .then(res => {
          if (res.data.toggle.status == 200) {
            //
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });
    },

    editar(item) {
      this.item = null;

      this.$nextTick(() => {
        this.novoMedico = null;
        this.validate = false;
        this.item = _.cloneDeep(item); 

        $("#restricaoModal").modal("show");
      });
    },

    remover() {
      if (confirm("Confirma remover essa restrição?")) {
        this.$store.commit("loading", true);

        let query = {
          q: [
            {
              name: "restricao_operadoras.destroy",
              id: "remover",
              parms: {
                id_restricao_operadora: this.item.id_restricao_operadora
              }
            }
          ]
        };

        this.axios
          .post("/aql", query)
          .then(res => {
            if (res.data.remover.status == 200) {
              this.load();
              $("#restricaoModal").modal("hide");
            }
          })
          .finally(() => {
            this.$store.commit("loading", false);
          });
      }
    },

    atualizar() {
      this.validate = true;

      this.$nextTick(() => {
        let invalids = $("#restricaoModal .invalid");

        if (invalids.length && $("#restricaoModal .invalid").is(":visible")) {
          this.$toast.add({
            severity: "error",
            summary: "Atenção",
            detail: "Verificar preenchimento dos campos.",
            life: 3000
          });
        } else {
          this.$store.commit("loading", true);

          this.item.id_procedimento_alternativo = this.item.alternativo 
            ? this.item.alternativo.id_procedimento
            : null;

          let query = {
            q: [
              {
                name: "restricao_operadoras.store",
                id: "atualizar",
                parms: {
                  ...this.item
                }
              }
            ]
          };

          this.axios
            .post("/aql", query)
            .then(res => {
              if (res.data.atualizar.status == 200) {
                this.load();
                $("#restricaoModal").modal("hide");
              }
            })
            .finally(() => {
              this.$store.commit("loading", false);
            });
        }
      });
    },

    load() {
      this.$store.commit("loading", true);

      let query = {
        q: [
          {
            name: "restricao_operadoras.index",
            id: "lista",
            parms: {
              id_operadora: this.id_operadora,
              cadastro: true, 
            }
          },
          {
            name: "medico_operadoras.index",
            id: "medicos",
            parms: {
              where: {
                id_operadora: this.id_operadora
              }
            }
          }
        ]
      };

      this.axios
        .post("/aql", query)
        .then(res => {
          if (res.data.lista.status == 200) {
            this.dados = res.data.lista.data;
          }

          if (res.data.medicos.status == 200) {
            this.medicos = res.data.medicos.data;
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });
    }
  },

  created() {
    this.$store.commit("loading", true);
  },

  mounted() {

    if ( !this.id_operadora ) { 

      this.breadcrumb = [
              { name: "Configurações", path: "/cadastros"},
              { name: "Restrições Gerais" },
          ];

      this.$store.commit('setBreadcrumb', this.breadcrumb);

    }

    this.load();

  }
};
</script>